import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import ViewModeNudge from './ViewModeNudge';
import { useViewMode } from '../../contexts/ViewModeContext';
import { isRecruiterShellEnabled, JOB_RADAR_ENABLED } from '../../config/features';
import { resolveRecruiterNavKey } from '../Recruiter/recruiterNavItems';
import RecruiterShell from '../Recruiter/RecruiterShell';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const { isViewingAsRecruiter } = useViewMode();

  // Recruiter B2B sidebar shell — only on recruiter product routes, in
  // recruiter view, and when the feature flag is enabled.
  const isRecruiterRoute = resolveRecruiterNavKey(location.pathname, location.search) !== null;
  const useRecruiterShell = isRecruiterShellEnabled() && isViewingAsRecruiter && isRecruiterRoute;

  const hideFooterOnRoutes = ['/messages', '/recruiter-inbox'];
  // The Job-Radar (Watch) tab is a full-height chat: hide the footer so the
  // composer stays pinned at the bottom (like the old Vee AI UI) instead of the
  // page scrolling past it into footer whitespace.
  const tabParam = new URLSearchParams(location.search).get('tab');
  const isRadarTab = JOB_RADAR_ENABLED &&
    (location.pathname === '/' || location.pathname === '/home2') &&
    (tabParam === 'watch' || tabParam === 'radar-ai' || tabParam === 'watch-legacy');
  const showFooter = !useRecruiterShell &&
    !hideFooterOnRoutes.includes(location.pathname) &&
    !location.pathname.match(/^\/community\/.+/) &&
    !isRadarTab;

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <ViewModeNudge />
      <main className="flex-1 flex flex-col">
        {useRecruiterShell ? <RecruiterShell>{children}</RecruiterShell> : children}
      </main>
      {showFooter && <Footer />}
    </div>
  );
};

export default Layout;
